import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const IlluminanceDetail1Widget = ({ widget, onValueUpdate }) => {
  const [illuminance, setIlluminance] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const value = Number(widget.items.$w1.value);
      setIlluminance(isNaN(value) ? 0 : value);
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Illuminance Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-500"
        style={{
          height: "40px",
          backgroundColor: isFlashing
            ? "hsl(var(--primary))"
            : "hsl(var(--primary) / 0.8)",
        }}
      >
        <Typography className="text-white font-bold text-lg">
          {illuminance.toFixed(0)} lux
        </Typography>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          <LightbulbIcon style={{ fontSize: "1.5rem", color: "white" }} />
        </div>
      </div>
    </div>
  );
};

export default IlluminanceDetail1Widget;
